import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { frame, cancelFrame } from "framer-motion";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import ProblemSolution from "./components/ProblemSolution";
import HowItWorks from "./components/HowItWorks";
import TrustSafety from "./components/TrustSafety";
import BentoGrid from "./components/BentoGrid";
import TargetAudience from "./components/TargetAudience";
import DownloadCTA from "./components/DownloadCTA";
import Footer from "./components/Footer";
import Links from "./pages/Links";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function LandingPage() {
  const lenisRef = useRef(null);

  useEffect(() => {
    function update(data) {
      lenisRef.current?.lenis?.raf(data.timestamp);
    }
    frame.update(update, true);
    return () => cancelFrame(update);
  }, []);

  return (
    <ReactLenis root options={{ autoRaf: false }} ref={lenisRef}>
      <div className="bg-surface text-on-surface font-body selection:bg-primary-container/30">
        <Nav />
        <Hero />
        <ProblemSolution />
        <HowItWorks />
        <TrustSafety />
        <BentoGrid />
        <TargetAudience />
        <DownloadCTA />
        <Footer />
      </div>
    </ReactLenis>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/waitinglist" element={<Navigate to="/" replace />} />
        <Route path="/links" element={<Links />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/t&c" element={<Navigate to="/terms" replace />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
